import { Link, createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { listProposals } from '@mkcore/portal/schema';
import { Badge, Card, EmptyState, Skeleton } from '@mkcore/ui';
import { call } from '@/lib/api';
import { formatDate, formatMoney } from '@/lib/format';
import { proposalTone } from '@/features/portal/proposals';

/** The proposals sent to the client (CO-0663). */
export const Route = createFileRoute('/portal/_client/proposals/')({
  component: Proposals,
});

function Proposals() {
  const { t } = useTranslation();
  const q = useQuery({ queryKey: ['portal', 'proposals'], queryFn: () => call(listProposals, {}) });
  if (!q.data) return <Skeleton className="h-32" />;
  return (
    <>
      <h1 className="text-2xl font-bold">{t('portal.modules.proposals')}</h1>
      {!q.data.items.length ? (
        <EmptyState title={t('portal.proposals.empty')} />
      ) : (
        <ul className="grid gap-2">
          {q.data.items.map((p) => (
            <li key={p.id}>
              <Card className="grid gap-1 p-4">
                <div className="flex flex-wrap items-center justify-between gap-2">
                  <Link to="/portal/proposals/$id" params={{ id: p.id }} className="font-bold hover:underline">
                    <span className="text-fg-3 tabular">{p.number}</span> {p.title}
                  </Link>
                  <Badge tone={proposalTone[p.state]}>{t(`portal.proposals.state.${p.state}`)}</Badge>
                </div>
                <p className="text-xs text-fg-2">
                  {[formatMoney(p.totalCents, p.currency), p.state === 'open' && p.validUntil && t('portal.proposals.validUntil', { date: formatDate(p.validUntil) })].filter(Boolean).join(' · ')}
                </p>
              </Card>
            </li>
          ))}
        </ul>
      )}
    </>
  );
}
